<div *ngIf="personList else docitemloading">

  <app-confirm-delete-product-part [(display)]="confirmDeleteOn"
                                   [typeConfirmation]="typeDeleteConfirmation"
                                   [confirmText]="confirmText"
                                   [messageText]="deleteMessageText"
                                   (done)="onDeleteConfirmation($event)"></app-confirm-delete-product-part>

  <p-table #personTable [value]="personList"
           dataKey="PERSID"
           [loading]="loading"
           selectionMode="single"
           [(selection)]="selectedPerson"
           (onRowSelect)="onRowSelect($event)"
           [rowHover]="true"
           [resizableColumns]="true"
           editMode="row"

           [rows]="rows"
           [paginator]="true"
           [showCurrentPageReport]="true"
           [rowsPerPageOptions]="[10,25,50]"
           [totalRecords]="totalRecords"
           currentPageReportTemplate="Показано с {first} по {last} из {totalRecords} записей"
           [filterDelay]="400"
           styleClass="p-datatable-gridlines p-datatable-striped"
           >

    <ng-template pTemplate="caption">
      <div class="grid vertical-container">
        <div class="col align-self-start">
          <p-selectButton [options]="showPersRowsOptions" [(ngModel)]="showRowOptions"
                          multiple="multiple" optionLabel="name" optionValue="value" optionDisabled="disabled"
                          (onChange)="onRowsOptionChange($event)" styleClass="mr-2 mt-2"
                          pTooltip="Показывать дополнительные поля сотрудника" tooltipPosition="top">
          </p-selectButton>
        </div>
        <div class="col align-self-end">
          <div class="grid justify-content-end">
            <p-button label="Обновить" icon="pi pi-refresh" (onClick)="reloadDocContent($event)" styleClass="ml-2 mt-2 mr-2" [disabled]="editMode"
                      pTooltip="Обновить содержимое таблицы" tooltipPosition="top"></p-button>
          </div>
        </div>
      </div>
    </ng-template>

    <ng-template pTemplate="header">
      <tr>
        <th style="width: 7rem"></th>
        <th pSortableColumn="PERSONLNAME" style="width: 20%" pResizableColumn>Фамилия <p-sortIcon field="PERSONLNAME"></p-sortIcon></th>
        <th pSortableColumn="PERSONFNAME" style="width:20%" pResizableColumn>Имя <p-sortIcon field="PERSONFNAME"></p-sortIcon></th>
        <th pSortableColumn="PERSONMNAME" style="width:10%" pResizableColumn>Отчество <p-sortIcon field="PERSONMNAME"></p-sortIcon></th>

        <th pSortableColumn="PERSONTITLE" style="width:15%" pResizableColumn>Должность <p-sortIcon field="PERSONTITLE"></p-sortIcon></th>
        <th pSortableColumn="PERSONCPHONE" style="width:10%" pResizableColumn>Мобильный <p-sortIcon field="PERSONCPHONE"></p-sortIcon></th>
        <th pSortableColumn="PERSONEMAIL" style="width:20%" pResizableColumn>E-mail <p-sortIcon field="PERSONEMAIL"></p-sortIcon></th>

        <th pSortableColumn="PERSONNOTE" style="width:15%" pResizableColumn *ngIf="seeNote">Примечание <p-sortIcon field="PERSONNOTE"></p-sortIcon></th>
        <th pSortableColumn="PERSONNOTE1" style="width:15%" pResizableColumn *ngIf="seeNote">Примечание 2 <p-sortIcon field="PERSONNOTE1"></p-sortIcon></th>
        <th pSortableColumn="PERSRESPONSIBLE" style="width:15%" pResizableColumn *ngIf="seeNote">Ответственность <p-sortIcon field="PERSRESPONSIBLE"></p-sortIcon></th>

        <th pSortableColumn="PERSONPHONE" style="width:10%" pResizableColumn *ngIf="seePhones">Телефон <p-sortIcon field="PERSONPHONE"></p-sortIcon></th>
        <th pSortableColumn="PERSONFAX" style="width:10%" pResizableColumn *ngIf="seePhones">Факс <p-sortIcon field="PERSONFAX"></p-sortIcon></th>
        <th pSortableColumn="PERSONPHONE1" style="width:10%" pResizableColumn *ngIf="seePhones">Телефон 2<p-sortIcon field="PERSONPHONE1"></p-sortIcon></th>
        <th pSortableColumn="PERSONFAX1" style="width:10%" pResizableColumn *ngIf="seePhones">Факс 2<p-sortIcon field="PERSONFAX1"></p-sortIcon></th>

        <th pSortableColumn="PERSONINDEX" style="width:10%" pResizableColumn *ngIf="seeAddress">Индекс <p-sortIcon field="PERSONINDEX"></p-sortIcon></th>
        <th pSortableColumn="PERSONCOUNTRY" style="width:10%" pResizableColumn *ngIf="seeAddress">Страна <p-sortIcon field="PERSONCOUNTRY"></p-sortIcon></th>
        <th pSortableColumn="PERSONCITY" style="width:10%" pResizableColumn *ngIf="seeAddress">Город <p-sortIcon field="PERSONCITY"></p-sortIcon></th>
        <th pSortableColumn="PERSONADDR1" style="width:10%" pResizableColumn *ngIf="seeAddress">Адрес <p-sortIcon field="PERSONADDR1"></p-sortIcon></th>
        <th pSortableColumn="PERSONADDR2" style="width:10%" pResizableColumn *ngIf="seeAddress">Адрес 2<p-sortIcon field="PERSONADDR2"></p-sortIcon></th>
        <th style="width: 3rem"></th>
      </tr>

      <tr>
        <th style="width: 7rem"></th>
        <th><input pInputText type="text" [(ngModel)]="fvPERSONLNAME" (input)="personTable.filter($event.target.value, 'PERSONLNAME', 'contains')" placeholder="Поиск" class="p-column-filter"></th>
        <th><input pInputText type="text" [(ngModel)]="fvPERSONFNAME" (input)="personTable.filter($event.target.value, 'PERSONFNAME', 'contains')" placeholder="Поиск" class="p-column-filter"></th>
        <th><input pInputText type="text" [(ngModel)]="fvPERSONMNAME" (input)="personTable.filter($event.target.value, 'PERSONMNAME', 'contains')" placeholder="Поиск" class="p-column-filter"></th>
        <th><input pInputText type="text" [(ngModel)]="fvPERSONTITLE" (input)="personTable.filter($event.target.value, 'PERSONTITLE', 'contains')" placeholder="Поиск" class="p-column-filter"></th>
        <th><input pInputText type="text" [(ngModel)]="fvPERSONCPHONE" (input)="personTable.filter($event.target.value, 'PERSONCPHONE', 'contains')" placeholder="Поиск" class="p-column-filter"></th>
        <th><input pInputText type="text" [(ngModel)]="fvPERSONEMAIL" (input)="personTable.filter($event.target.value, 'PERSONEMAIL', 'contains')" placeholder="Поиск" class="p-column-filter"></th>

        <th *ngIf="seeNote"><input pInputText type="text" [(ngModel)]="fvPERSONNOTE" (input)="personTable.filter($event.target.value, 'PERSONNOTE', 'contains')" placeholder="Поиск" class="p-column-filter"></th>
        <th *ngIf="seeNote"><input pInputText type="text" [(ngModel)]="fvPERSONNOTE1" (input)="personTable.filter($event.target.value, 'PERSONNOTE1', 'contains')" placeholder="Поиск" class="p-column-filter"></th>
        <th *ngIf="seeNote"><input pInputText type="text" [(ngModel)]="fvPERSRESPONSIBLE" (input)="personTable.filter($event.target.value, 'PERSRESPONSIBLE', 'contains')" placeholder="Поиск" class="p-column-filter"></th>

        <th *ngIf="seePhones"><input pInputText type="text" [(ngModel)]="fvPERSONPHONE" (input)="personTable.filter($event.target.value, 'PERSONPHONE', 'contains')" placeholder="Поиск" class="p-column-filter"></th>
        <th *ngIf="seePhones"><input pInputText type="text" [(ngModel)]="fvPERSONFAX" (input)="personTable.filter($event.target.value, 'PERSONFAX', 'contains')" placeholder="Поиск" class="p-column-filter"></th>
        <th *ngIf="seePhones"><input pInputText type="text" [(ngModel)]="fvPERSONPHONE1" (input)="personTable.filter($event.target.value, 'PERSONPHONE1', 'contains')" placeholder="Поиск" class="p-column-filter"></th>
        <th *ngIf="seePhones"><input pInputText type="text" [(ngModel)]="fvPERSONFAX1" (input)="personTable.filter($event.target.value, 'PERSONFAX1', 'contains')" placeholder="Поиск" class="p-column-filter"></th>

        <th *ngIf="seeAddress"><input pInputText type="text" [(ngModel)]="fvPERSONINDEX" (input)="personTable.filter($event.target.value, 'PERSONINDEX', 'contains')" placeholder="Поиск" class="p-column-filter"></th>
        <th *ngIf="seeAddress"><input pInputText type="text" [(ngModel)]="fvPERSONCOUNTRY" (input)="personTable.filter($event.target.value, 'PERSONCOUNTRY', 'contains')" placeholder="Поиск" class="p-column-filter"></th>
        <th *ngIf="seeAddress"><input pInputText type="text" [(ngModel)]="fvPERSONCITY" (input)="personTable.filter($event.target.value, 'PERSONCITY', 'contains')" placeholder="Поиск" class="p-column-filter"></th>
        <th *ngIf="seeAddress"><input pInputText type="text" [(ngModel)]="fvPERSONADDR1" (input)="personTable.filter($event.target.value, 'PERSONADDR1', 'contains')" placeholder="Поиск" class="p-column-filter"></th>
        <th *ngIf="seeAddress"><input pInputText type="text" [(ngModel)]="fvPERSONADDR2" (input)="personTable.filter($event.target.value, 'PERSONADDR2', 'contains')" placeholder="Поиск" class="p-column-filter"></th>

        <th></th>
      </tr>

    </ng-template>
    <ng-template pTemplate="body" let-person let-editing="editing" let-ri="rowIndex">
      <tr [pSelectableRow]="person" [pEditableRow]="person">

        <td>
          <button *ngIf="!editing && !editMode" pButton pRipple type="button" pInitEditableRow icon="pi pi-pencil" (click)="onDiRowEditInit(person)" class="p-button-rounded p-button-text"></button>
          <button *ngIf="editing" pButton pRipple type="button" pSaveEditableRow icon="pi pi-save" (click)="onDiRowEditSave(person)" class="p-button-rounded p-button-text p-button-success mr-2"></button>
          <button *ngIf="editing" pButton pRipple type="button" pCancelEditableRow icon="pi pi-times" (click)="onDiRowEditCancel(person, ri)" class="p-button-rounded p-button-text p-button-danger"></button>
        </td>

        <td >
          <p-cellEditor>
            <ng-template pTemplate="input">
              <input pInputText type="text" [(ngModel)]="person.PERSONLNAME" [style]="{'width':'100%'}" (keydown)="$event.stopPropagation()">
            </ng-template>
            <ng-template pTemplate="output">
              <div class="align-self-baseline" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis">
                <a [routerLink]="['/edit-person', person.PERSID]">{{person.PERSONLNAME}}</a>
              </div>
            </ng-template>
          </p-cellEditor>
        </td>

        <td >
          <p-cellEditor>
            <ng-template pTemplate="input">
              <input pInputText type="text" [(ngModel)]="person.PERSONFNAME" [style]="{'width':'100%'}" (keydown)="$event.stopPropagation()">
            </ng-template>
            <ng-template pTemplate="output">
              <div class="align-self-baseline" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis">
                <a [routerLink]="['/edit-person', person.PERSID]">{{person.PERSONFNAME}}</a>
              </div>
            </ng-template>
          </p-cellEditor>
        </td>

        <td >
          <p-cellEditor>
            <ng-template pTemplate="input">
              <input pInputText type="text" [(ngModel)]="person.PERSONMNAME" [style]="{'width':'100%'}" (keydown)="$event.stopPropagation()">
            </ng-template>
            <ng-template pTemplate="output">
              <div class="align-self-baseline" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis">
                <a [routerLink]="['/edit-person', person.PERSID]">{{person.PERSONMNAME}}</a>
              </div>
            </ng-template>
          </p-cellEditor>
        </td>

        <td >
          <p-cellEditor>
            <ng-template pTemplate="input"><input pInputText type="text" [(ngModel)]="person.PERSONTITLE" [style]="{'width':'100%'}" (keydown)="$event.stopPropagation()"></ng-template>
            <ng-template pTemplate="output"><div class="align-self-baseline" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis">{{person.PERSONTITLE}}</div></ng-template>
          </p-cellEditor>
        </td>

        <td >
          <p-cellEditor>
            <ng-template pTemplate="input"><p-inputMask [(ngModel)]="person.PERSONCPHONE" mask="(999) 999-9999" characterPattern="[0-9]" [style]="{'width':'100%'}" (keydown)="$event.stopPropagation()"></p-inputMask></ng-template>
            <ng-template pTemplate="output"><div class="align-self-baseline" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis">{{person.PERSONCPHONE}}</div></ng-template>
          </p-cellEditor>
        </td>

        <td >
          <p-cellEditor>
            <ng-template pTemplate="input"><input pInputText type="text" [(ngModel)]="person.PERSONEMAIL" [style]="{'width':'100%'}" (keydown)="$event.stopPropagation()"></ng-template>
            <ng-template pTemplate="output"><div class="align-self-baseline" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis">{{person.PERSONEMAIL}}</div></ng-template>
          </p-cellEditor>
        </td>

        <td *ngIf="seeNote">
          <p-cellEditor>
            <ng-template pTemplate="input"><input pInputText type="text" [(ngModel)]="person.PERSONNOTE" [style]="{'width':'100%'}" (keydown)="$event.stopPropagation()"></ng-template>
            <ng-template pTemplate="output"><div class="align-self-baseline" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis">{{person.PERSONNOTE}}</div></ng-template>
          </p-cellEditor>
        </td>

        <td *ngIf="seeNote">
          <p-cellEditor>
            <ng-template pTemplate="input"><input pInputText type="text" [(ngModel)]="person.PERSONNOTE1" [style]="{'width':'100%'}" (keydown)="$event.stopPropagation()"></ng-template>
            <ng-template pTemplate="output"><div class="align-self-baseline" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis">{{person.PERSONNOTE1}}</div></ng-template>
          </p-cellEditor>
        </td>

        <td *ngIf="seeNote" class="overflow-visible" >
          <p-cellEditor>
            <ng-template pTemplate="input">
              <p-dropdown [options]="signPersonOptions" [(ngModel)]="person.PERSRESPONSIBLE" optionLabel="value" optionValue="index" [style]="{'width':'100%'}" (keydown)="$event.stopPropagation()"></p-dropdown>
            </ng-template>
            <ng-template pTemplate="output"><div class="col" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis">{{showPersonSignOption(person.PERSRESPONSIBLE)}}</div></ng-template>
          </p-cellEditor>
        </td>

        <td *ngIf="seePhones">
          <p-cellEditor>
            <ng-template pTemplate="input"><p-inputMask [(ngModel)]="person.PERSONPHONE" mask="(999) 999-9999" characterPattern="[0-9]" [style]="{'width':'100%'}" (keydown)="$event.stopPropagation()"></p-inputMask></ng-template>
            <ng-template pTemplate="output"><div class="align-self-baseline" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis">{{person.PERSONPHONE}}</div></ng-template>
          </p-cellEditor>
        </td>

        <td *ngIf="seePhones">
          <p-cellEditor>
            <ng-template pTemplate="input"><p-inputMask [(ngModel)]="person.PERSONFAX" mask="(999) 999-9999" characterPattern="[0-9]" [style]="{'width':'100%'}" (keydown)="$event.stopPropagation()"></p-inputMask></ng-template>
            <ng-template pTemplate="output"><div class="align-self-baseline" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis">{{person.PERSONFAX}}</div></ng-template>
          </p-cellEditor>
        </td>

        <td *ngIf="seePhones">
          <p-cellEditor>
            <ng-template pTemplate="input"><p-inputMask [(ngModel)]="person.PERSONPHONE1" mask="(999) 999-9999" characterPattern="[0-9]" [style]="{'width':'100%'}" (keydown)="$event.stopPropagation()"></p-inputMask></ng-template>
            <ng-template pTemplate="output"><div class="align-self-baseline" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis">{{person.PERSONPHONE1}}</div></ng-template>
          </p-cellEditor>
        </td>

        <td *ngIf="seePhones">
          <p-cellEditor>
            <ng-template pTemplate="input"><p-inputMask [(ngModel)]="person.PERSONFAX1" mask="(999) 999-9999" characterPattern="[0-9]" [style]="{'width':'100%'}" (keydown)="$event.stopPropagation()"></p-inputMask></ng-template>
            <ng-template pTemplate="output"><div class="align-self-baseline" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis">{{person.PERSONFAX1}}</div></ng-template>
          </p-cellEditor>
        </td>

        <td *ngIf="seeAddress">
          <p-cellEditor>
            <ng-template pTemplate="input"><input pInputText type="text" [(ngModel)]="person.PERSONINDEX" [style]="{'width':'100%'}" (keydown)="$event.stopPropagation()"></ng-template>
            <ng-template pTemplate="output"><div class="align-self-baseline" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis">{{person.PERSONINDEX}}</div></ng-template>
          </p-cellEditor>
        </td>

        <td *ngIf="seeAddress">
          <p-cellEditor>
            <ng-template pTemplate="input"><input pInputText type="text" [(ngModel)]="person.PERSONCOUNTRY" [style]="{'width':'100%'}" (keydown)="$event.stopPropagation()"></ng-template>
            <ng-template pTemplate="output"><div class="align-self-baseline" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis">{{person.PERSONCOUNTRY}}</div></ng-template>
          </p-cellEditor>
        </td>

        <td *ngIf="seeAddress">
          <p-cellEditor>
            <ng-template pTemplate="input"><input pInputText type="text" [(ngModel)]="person.PERSONCITY" [style]="{'width':'100%'}" (keydown)="$event.stopPropagation()"></ng-template>
            <ng-template pTemplate="output"><div class="align-self-baseline" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis">{{person.PERSONCITY}}</div></ng-template>
          </p-cellEditor>
        </td>

        <td *ngIf="seeAddress">
          <p-cellEditor>
            <ng-template pTemplate="input"><input pInputText type="text" [(ngModel)]="person.PERSONADDR1" [style]="{'width':'100%'}" (keydown)="$event.stopPropagation()"></ng-template>
            <ng-template pTemplate="output"><div class="align-self-baseline" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis">{{person.PERSONADDR1}}</div></ng-template>
          </p-cellEditor>
        </td>

        <td *ngIf="seeAddress">
          <p-cellEditor>
            <ng-template pTemplate="input"><input pInputText type="text" [(ngModel)]="person.PERSONADDR2" [style]="{'width':'100%'}" (keydown)="$event.stopPropagation()"></ng-template>
            <ng-template pTemplate="output"><div class="align-self-baseline" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis">{{person.PERSONADDR2}}</div></ng-template>
          </p-cellEditor>
        </td>

        <td><button pButton pRipple type="button" icon="pi pi-paperclip" (click)="onExtendedEdit(person)" class="p-button-rounded p-button-text p-button-info"></button></td>
      </tr>
    </ng-template>

    <ng-template pTemplate="summary">
      <div class="grid">
        <div class="col">
          <div class="grid formgrid p-jc-start">
            <p-button label="Добавить сотрудника" icon="pi pi-plus" (onClick)="onAddRow($event)" styleClass="ml-2 mt-2 mr-2" [disabled]="editMode"
                      pTooltip="Добавить нового сотрудника в компанию" tooltipPosition="top"></p-button>
            <p-button label="Добавить из основной организации"
                      icon="pi pi-users"
                      (onClick)="onAddFromMainOrgClick($event)"
                      styleClass="ml-2 mt-2 mr-2"
                      [disabled]="editMode"
                      pTooltip="Добавить сотрудников из основной организации группы компаний"
                      tooltipPosition="top">
            </p-button>
          </div>
        </div>
        <div class="col">
          <div class="grid formgrid justify-content-end">
            <p-button label="Удалить всех сотрудников" icon="pi pi-trash" (onClick)="onRemoveAllRow($event)" styleClass="p-button-danger mt-2 mr-2" [disabled]="true"
                      pTooltip="Удалить всех сотрудников в компании" tooltipPosition="top"></p-button>
            <p-button label="Удалить сотрудника" icon="pi pi-minus" (onClick)="onRemoveRow($event)" styleClass="p-button-warning mt-2 mr-2" [disabled]="editMode || !selectedPerson"
                      pTooltip="Убрать выбранного сотрудника" tooltipPosition="top"></p-button>
          </div>
        </div>
      </div>
    </ng-template>

    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="8">Сотрудники отсутствуют</td>
      </tr>
    </ng-template>
  </p-table>

  <p-dialog [header]="'Добавить из: ' + (mainOrgName || 'основной организации')"
            [(visible)]="showFromMainOrgDialog"
            [modal]="true"
            [closable]="true"
            [style]="{'width': '520px', 'max-height': '80vh'}"
            (onHide)="onCancelFromMainOrgDialog()">

    <!-- Loading state -->
    <div *ngIf="mainOrgPersonsLoading" class="flex justify-content-center p-4">
      <p-progressSpinner [style]="{'width':'40px','height':'40px'}"></p-progressSpinner>
    </div>

    <!-- Error / info messages -->
    <p *ngIf="!mainOrgPersonsLoading && mainOrgError" class="text-orange-500 mt-2">
      {{ mainOrgError }}
    </p>

    <!-- All persons already present -->
    <p *ngIf="!mainOrgPersonsLoading && !mainOrgError && mainOrgPersons?.length === 0"
       class="text-600 mt-2">
      Все сотрудники основной организации уже присутствуют в этой компании.
    </p>

    <!-- Person multiselect list -->
    <p-listbox *ngIf="!mainOrgPersonsLoading && !mainOrgError && mainOrgPersons?.length > 0"
               [options]="mainOrgPersons"
               [(ngModel)]="selectedPersonsToCopy"
               [multiple]="true"
               [checkbox]="true"
               [filter]="true"
               filterPlaceholder="Поиск..."
               optionLabel="PERSONLNAME"
               [listStyle]="{'max-height':'300px'}"
               [style]="{'width':'100%'}">
      <ng-template let-person pTemplate="item">
        <span>{{ person.PERSONLNAME }} {{ person.PERSONFNAME }} {{ person.PERSONMNAME }}</span>
        <span *ngIf="person.PERSONTITLE" class="text-500 ml-2 text-sm">— {{ person.PERSONTITLE }}</span>
      </ng-template>
    </p-listbox>

    <ng-template pTemplate="footer">
      <p-button label="Отмена"
                icon="pi pi-times"
                styleClass="p-button-text"
                (onClick)="onCancelFromMainOrgDialog()">
      </p-button>
      <p-button label="Скопировать выбранных"
                icon="pi pi-check"
                [disabled]="!selectedPersonsToCopy.length || copyInProgress"
                [loading]="copyInProgress"
                (onClick)="onConfirmCopyFromMainOrg()">
      </p-button>
    </ng-template>
  </p-dialog>
</div>
<ng-template #docitemloading>
  <p>Контакты загружаются...</p>
</ng-template>
